import React from 'react';
import LegalDocument from '../components/LegalDocument';
import legalContent from '../legal/legalContent.json';

// The words come from the app's canonical source; this page only renders
// them. See src/components/LegalDocument.js.
const TermsOfServicePage = () => (
  <LegalDocument document={legalContent.termsOfService} lastUpdated={legalContent.lastUpdated} />
);

export default TermsOfServicePage;
